import { render } from "./pushAsk.vue?vue&type=template&id=1fc6d516&scoped=true"
import script from "./pushAsk.vue?vue&type=script&lang=js"
export * from "./pushAsk.vue?vue&type=script&lang=js"

import "./pushAsk.vue?vue&type=style&index=0&id=1fc6d516&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc6d516"]])

export default __exports__